<template>
  <div>
    <div class="card-title">
      <form @submit.prevent="getSchoolsSearchlist()">
        <label for>
          <h4>Provide School Name and Alias</h4>
        </label>
        <div class="row">
          <div class="col py-4 text-left px-4 mx-2">
            <div class="form-group">
              <input
                type="text"
                class="form-control w-100"
                id="searchInput"
                v-model="sch_name"
                style="border-radius: 25px; width:100%"
                placeholder="Enter Part Of School Name"
              />
            </div>
            <div class="form-group">
              <input
                type="text"
                class="form-control w-100"
                id="searchInput"
                v-model="sch_paycode"
                style="border-radius: 25px; width:100%"
                placeholder="Enter Alias"
              />
            </div>
          </div>
          <div class="col py-4 text-right px-4 mx-2">
            <div class="custom-file"></div>
            <div class>
              <button type="submit" class="btn btn-primary" style="border-radius: 25px;">
                <i v-if="loading" class="fa fa-spin fa-spinner"></i>
                <template v-else>
                  <i class="fa fa-search" aria-hidden="true"></i> Search
                </template>
              </button>
              <!-- <button type="button" class="btn btn-primary" @click="saveSchool" >Save</button> -->
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="py-5">
      <div class="row m-0">
        <!-- <div class="form-group col-md-4">
                  <select id="bank" class="form-control" v-model="sr_schoolid" @input="getTransacbySchooID" >
                  <option value="">Select School</option>
                  <option v-for="(school, i) in schools" :value="school.Sz_orgid" :key="i">{{school.sz_orgname | capitalize }}</option>
                  </select>
        </div>-->
        <div class="form-group col-md-2" hidden>
          <b-form-datepicker id="trans-startdate" v-model="startdate" class="mb-4"></b-form-datepicker>
        </div>
        <div class="form-group col-md-2" hidden></div>
        <div class="form-group col-md-2">
          <button class="btn btn-outline-info" style="border-radius: 25px; font-size: 12px" hidden>
            Load Data
            <!-- <i class="fas fa-angle-down" style="padding: 3px;"></i> -->
          </button>
        </div>
      </div>
      <div class="card">
        <div class="card-header bg-lighter p-2">
          <div class="row m-0 align-items-center">
            <div class="col-md-2 px-4">
              <h6>
                School Name
                <span class="badge badge-primary" style="font-size: 12px"></span>
              </h6>
            </div>
            <div class="col-md-6 w-60">
              <input
                type="text"
                class="form-control w-100"
                id="searchInput"
                v-model="filter_name"
                style="border-radius: 25px; width:100%"
                placeholder
              />
            </div>
          </div>
        </div>
        <div class="card-body py-0 px-3" style="overflow-y: scroll; height:80vh;">
          <table class="table align-items-center table-flush">
            <thead slot="columns" class="default-color-dark z-depth-2 text-white text-center">
              <th>Merchant ID</th>
              <th>Pay Code</th>
              <th>School Name</th>
            </thead>
            <tbody v-for="(row, i) in theData" :key="i">
              <td>
                <div class="media align-items-center">
                  <div class="media-body">
                    <span class="name mb-0 text-sm">
                      <div class="mb-0 text-sm">
                        <p class="mb-1">{{row.merchantId }}</p>
                      </div>
                    </span>
                  </div>
                </div>
              </td>
              <td>
                <div class="media align-items-center">
                  <div class="media-body">
                    <span class="name mb-0 text-sm">
                      <div class="mb-0 text-sm">
                        <p class="mb-1">{{row.paytype }}</p>
                      </div>
                    </span>
                  </div>
                </div>
              </td>
              <td>
                <div class="media align-items-center">
                  <div class="media-body">
                    <span class="name mb-0 text-sm">
                      <div class="mb-0 text-sm">
                        <p class="mb-1">{{row.name }}</p>
                      </div>
                    </span>
                  </div>
                </div>
              </td>
            </tbody>
          </table>
          <div class="text-center mt-2" v-if="loading">
            <i style="font-size:80px" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
          </div>
          <p
            v-if="tabdata.length === 0 && !loading"
            class="text-muted text-center lead font-weight-bold mt-2"
          >Please no data in selected school</p>
          <div class="d-flex justify-content-center">
            <!--Pagination -->
            <nav class="my-4 pt-2">
              <ul class="pagination pagination-circle pg-blue mb-0">
                <!--Arrow left-->
                <li
                  class="page-item"
                  :class="{'disabled': (currPage === 1)}"
                  @click.prevent="setPage(currPage-1)"
                >
                  <a class="page-link" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </a>
                </li>
                <!--Numbers-->
                <li
                  class="page-item"
                  v-for="(n,i) in totalPage"
                  :key="i"
                  :class="{'active': (currPage === (n))}"
                  @click.prevent="setPage(n)"
                >
                  <a class="page-link">{{n}}</a>
                </li>
                <!--Arrow right-->
                <li
                  class="page-item"
                  :class="{'disabled': (currPage === totalPage)}"
                  @click.prevent="setPage(currPage+1)"
                >
                  <a class="page-link" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </a>
                </li>
              </ul>
            </nav>
            <!--/Pagination -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import http from "@/network/Base.js";
import { mapState } from "vuex";
import Badge from "@/components/Badge.vue";
// import BaseDropdown from '@/components/BaseDropdown.vue';

export default {
  components: {
    Badge,
    // "base-dropdown":BaseDropdown
  },
  data() {
    return {
      loading: false,
      tabdata: [],
      sch_name: "",
      sch_paycode: "",
      search: "",
      countOfPage: 10,
      sr_schoolid: "",
      startdate: "",
      enddate: "",
      currPage: 1,
      schools: [],
      filter_name: "",
      details: [],
    };
  },
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    },
  },
  methods: {
    setPage(idx) {
      if (idx <= 0 || idx > this.totalPage) {
        return;
      }
      this.currPage = idx;
    },
    getSchoolsSearchlist() {
      //this.sr_schoolid = value.target.value
      this.$Progress.start();
      this.loading = true;
      http()
        .post(
          "https://www.ikolilu.com/api/v1.0/ik_providers_.php/VerifySchools/",
          { name: this.sch_name, paycode: this.sch_paycode }
        )
        .then(({ data }) => {
          // console.log(data)
          if (data == "null" || data == null) {
            this.tabdata = [];
          } else {
            this.tabdata = data;
          }
        })
        .catch((err) => {
          this.$snotify.error("Could not get the list of schools");
          this.$Progress.finish();
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },

  computed: {
    ...mapState({
      providerid: (state) => state.provider.provider_id,
      selecteSchool: (state) => state.provider.school,
    }),
    filteredRows: function () {
      var filter_name = this.filter_name.toLowerCase();
      return this.filter_name.trim() !== ""
        ? this.tabdata.filter((d) => {
            return d.name.toLowerCase().indexOf(filter_name) > -1;
          })
        : this.tabdata;
    },
    pageStart: function () {
      return (this.currPage - 1) * this.countOfPage;
    },
    totalPage: function () {
      return Math.ceil(this.filteredRows.length / this.countOfPage);
    },
    theData() {
      // console.log(this.filteredRows)
      return this.filteredRows.slice(
        this.pageStart,
        this.pageStart + this.countOfPage
      );
    },
  },
  created() {
    var d = new Date();
    // this.getSchoolsSearchlist();
    // this.getSchools()
    // this.getTransac()
    // this.startdate = this.d.Date()
    // this.enddate = this.d.Now()
  },
};
</script>
<style scoped>
</style>